import type { Attachment } from "../common/types/Attachment";
import { joinWith } from "../common/utils/array.util";

export const emptyImage =
    "data:image/svg+xml;charset=utf8,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E";

export function getImageSizeFromFile(file: File) {
    return new Promise<{ width: number; height: number }>((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            resolve({ width: image.width, height: image.height });
        };
        image.onerror = reject;
        image.src = url;
    });
}

export function randomUUIDFilename() {
    const timestamp = new Date().getTime().toString();
    const filename = `${crypto.randomUUID()}-${timestamp}`;
    return filename;
}

export function attachmentFromFile(file: File): Attachment & { file: File } {
    const attachment: Attachment & { file: File } = {
        id: crypto.randomUUID(),
        filename: file.name,
        url: URL.createObjectURL(file),
        mimeType: file.type,
        file,
    };
    return attachment;
}

export function validateSupportedFiletype(
    filetype: string,
    supportedFiletypes: string[],
) {
    if (!supportedFiletypes.includes(filetype))
        throw new Error(
            `Supported ${
                supportedFiletypes.length <= 1 ? "filetype" : "filetypes"
            }: ${joinWith(supportedFiletypes, ", ", "and")}`,
        );
}
